import io from 'socket.io-client';
const sockets = io('https://urbex-video-c3a13ff407a0.herokuapp.com/', { autoConnect: true, forceNew: true });
// const sockets = io('/');
export default sockets;
